
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Country } from "./useCountriesAndConstituencies";

export interface UserFilters {
  role: string;
  verified: string;
  country: string;
  verification: string;
}

export type UserSortOption = 'newest' | 'oldest' | 'name_asc' | 'name_desc';

interface UserFiltersProps {
  countries: Country[];
  filters: UserFilters;
  onFilterChange: (filters: UserFilters) => void;
  sortOption: UserSortOption;
  onSortChange: (sortOption: UserSortOption) => void;
}

const UserFilters = ({ 
  countries, 
  filters, 
  onFilterChange, 
  sortOption, 
  onSortChange 
}: UserFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      {/* Role Filter */}
      <Select 
        value={filters.role} 
        onValueChange={(value) => onFilterChange({ ...filters, role: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Filter by role" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Roles</SelectItem>
          <SelectItem value="public">Public</SelectItem>
          <SelectItem value="pollster">Pollster</SelectItem>
          <SelectItem value="media">Media</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
          <SelectItem value="super_admin">Super Admin</SelectItem>
        </SelectContent>
      </Select>

      {/* Verified Filter */}
      <Select 
        value={filters.verified} 
        onValueChange={(value) => onFilterChange({ ...filters, verified: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Filter by status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="verified">Verified</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
        </SelectContent>
      </Select>

      {/* Verification Filter */}
      <Select 
        value={filters.verification} 
        onValueChange={(value) => onFilterChange({ ...filters, verification: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Filter by verification" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Verification</SelectItem>
          <SelectItem value="verified">ID Verified</SelectItem>
          <SelectItem value="pending">ID Pending</SelectItem>
          <SelectItem value="rejected">ID Rejected</SelectItem>
        </SelectContent>
      </Select>

      {/* Country Filter */}
      <Select 
        value={filters.country} 
        onValueChange={(value) => onFilterChange({ ...filters, country: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Filter by country" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Countries</SelectItem>
          {countries.map((country) => (
            <SelectItem key={country.code} value={country.code}>
              {country.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Sort Option */}
      <Select 
        value={sortOption} 
        onValueChange={(value) => onSortChange(value as UserSortOption)}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="newest">Newest First</SelectItem>
          <SelectItem value="oldest">Oldest First</SelectItem>
          <SelectItem value="name_asc">Name A-Z</SelectItem>
          <SelectItem value="name_desc">Name Z-A</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default UserFilters;
export type { UserFilters };
